
import { useMutation } from '@vue/apollo-composable';
import {
  type Ticket,
  type TicketCategory,
  type TicketMessage,
  type ReplyTicketInput,
  TicketStatus,
  TicketPriority,
} from '@/types/custom-ticket-types';
import type { Maybe, CreateTicketCategoryInput, CreateTicketInput, UpdateTicketStatusInput } from '@/types/composition-functions';
import {
  CREATE_TICKET_CATEGORY_MUTATION,
  UPDATE_TICKET_CATEGORY_MUTATION,
  CREATE_TICKET_MUTATION,
  REPLY_TICKET_MUTATION,
  UPDATE_TICKET_STATUS_MUTATION,
} from '@/graphql/mutations/tickets';

export const useTicketMutations = () => {
  // Create Category
  const { mutate: createCategory, loading: creatingCategory, onDone: onCategoryCreated, onError: onCategoryError } = useMutation<{ createTicketCategory: TicketCategory }, { input: CreateTicketCategoryInput }>(CREATE_TICKET_CATEGORY_MUTATION);

  // Update Category
  const { mutate: updateCategory, loading: updatingCategory, onDone: onCategoryUpdated, onError: onUpdateCategoryError } = useMutation<{ updateTicketCategory: TicketCategory }, { id: string, name?: string, priority?: TicketPriority, auto_response?: string }>(UPDATE_TICKET_CATEGORY_MUTATION);

  // Create Ticket
  const { mutate: createTicket, loading: creatingTicket, onDone: onTicketCreated, onError: onTicketError } = useMutation<{ createTicket: Ticket }, { input: CreateTicketInput }>(CREATE_TICKET_MUTATION);

  // Reply Ticket
  const { mutate: replyTicket, loading: replyingTicket, onDone: onTicketReplied, onError: onReplyError } = useMutation<{ replyTicket: TicketMessage }, { input: ReplyTicketInput }>(REPLY_TICKET_MUTATION);

  // Update Status
  const { mutate: updateStatus, loading: updatingStatus, onDone: onStatusUpdated, onError: onStatusError } = useMutation<{ updateTicketStatus: Ticket }, { input: UpdateTicketStatusInput }>(UPDATE_TICKET_STATUS_MUTATION);

  return {
    createCategory,
    creatingCategory,
    onCategoryCreated,
    onCategoryError,

    updateCategory,
    updatingCategory,
    onCategoryUpdated,
    onUpdateCategoryError,

    createTicket,
    creatingTicket,
    onTicketCreated,
    onTicketError,

    replyTicket,
    replyingTicket,
    onTicketReplied,
    onReplyError,

    updateStatus,
    updatingStatus,
    onStatusUpdated,
    onStatusError,
  };
};
